import React, { useState } from "react";
import { Copy, Check, Share2 } from "lucide-react";

/**
 * Share button for permanent recruiting profile URLs.
 * Provides: Copy Link, X (Twitter) share intent, native share (mobile).
 */
export default function ShareButton({ url, title = "Check out this CBR Prospect", label = "Share Profile", hashtags = ["CBRProspects", "CanadianBaseball"] }) {
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);

  const fullUrl = url || (typeof window !== "undefined" ? window.location.href : "");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (e) {
      /* fallback noop */
    }
  };

  const xUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(fullUrl)}&hashtags=${encodeURIComponent(hashtags.join(","))}`;

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, url: fullUrl });
      } catch (_) {}
    } else {
      setOpen(!open);
    }
  };

  return (
    <div className="relative inline-block">
      <button
        data-testid="share-profile-button"
        onClick={nativeShare}
        className="inline-flex items-center gap-2 bg-[#0A192F] hover:bg-[#1a2a4a] text-white px-4 py-2 text-xs font-semibold uppercase tracking-wider rounded-sm"
      >
        <Share2 className="w-4 h-4" /> {label}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-64 bg-white border border-slate-200 shadow-md rounded-sm z-30 p-3 text-sm">
          <button
            data-testid="share-copy-link"
            onClick={copy}
            className="w-full flex items-center gap-2 px-2 py-2 hover:bg-slate-50 text-left"
          >
            {copied ? <Check className="w-4 h-4 text-emerald-600" /> : <Copy className="w-4 h-4" />}
            <span>{copied ? "Copied!" : "Copy Link"}</span>
          </button>
          <a
            data-testid="share-x"
            href={xUrl}
            target="_blank"
            rel="noreferrer"
            className="w-full flex items-center gap-2 px-2 py-2 hover:bg-slate-50"
          >
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2H21.5l-7.5 8.57L23 22h-6.937l-5.45-7.13L4.5 22H1.244l8.022-9.166L1 2h7.06l4.93 6.522L18.244 2zm-2.43 18.05h1.92L7.27 3.85H5.207L15.814 20.05z"/></svg>
            <span>Share on X</span>
          </a>
          <div className="mt-2 pt-2 border-t border-slate-100">
            <div className="text-[10px] uppercase tracking-wider text-slate-400">Permanent URL</div>
            <div className="mt-1 font-mono text-[11px] break-all text-slate-600 bg-slate-50 p-2">{fullUrl}</div>
          </div>
        </div>
      )}
    </div>
  );
}
